import service from '../../services/userservice'
import { getToken, setToken } from '../auth'

const user = {
  state: {
    usuario: {},
    status: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    rules: [],
    routers: [],
    drawer: [],
    setting: {
      articlePlatform: []
    },
    operations: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER: (state, user) => {
      state.usuario = user
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_RULES: (state, rules) => {
      state.rules = rules
    },
    SET_ROUTERS: (state, routers) => {
      state.routers = routers
    },
    SET_DRAWER: (state, drawer) => {
      state.drawer = drawer
    }
  },

  actions: {
    // Login por nome do usuário
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        service.login(userInfo).then(resp => {
          if (resp.status === 200) {
            commit('SET_USER', resp.data.data)
            // console.log(resp.data);
            // commit('SET_RULES', data.msg.routes)
            setToken(resp.data.token)
            // setRules(data.routes)
            resolve({ status: 1, msg: 'ok', rule: resp.data.data })
          } else {
            resolve({ status: 0, msg: 'error' })
          }
        }).catch(error => {
          reject(error)
          return false
        })
      })
    },

    LoadMenus ({ commit }, rule) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        loadDrawer(rule).then(resp => {
          if (resp.status === 200) {
            commit('SET_DRAWER', resp.data.msg.drawer)
            resolve({ msg: 'ok' })
          }
          resolve({ msg: 'erro' })
        }).catch(error => {
          reject(error)
        })
      })
    },
    // Obter informações do usuário
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        getUserInfo(state.token).then(response => {
          if (!response.data) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data
          commit('SET_RULES', data.rules)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // Sair
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_RULES', [])
          // eslint-disable-next-line no-undef
          removeToken()
          // eslint-disable-next-line no-undef
          setRules([])
          resolve({ msg: 'ok' })
        }).catch(error => {
          reject(error)
        })
      })
    },

    // Front end
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        // eslint-disable-next-line no-undef
        removeToken()
        // eslint-disable-next-line no-undef
        setRules([])
        resolve()
      })
    },

    // Modifique dinamicamente as permissões
    ChangeRules ({ commit }, rule) {
      return new Promise(resolve => {
        commit('SET_TOKEN', rule)
        setToken(rule)
        // eslint-disable-next-line no-undef
        getUserInfo(rule).then(response => {
          const data = response.data
          commit('SET_RULES', data.rules)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }

    // GenerateRoutes ({ commit }, data) {
    //   var rules = JSON.parse(data)
    //   var routeAux = []
    //   rules.forEach(function (value, index) {
    //     sidebarLinks.forEach(function (item, pos) {
    //       if (`/${value.grupo}/${value.rota}` === item.path) {
    //         routeAux.push(item)
    //       }
    //     })
    //   })
    //   commit('SET_ROUTERS', routeAux)
    // }
    //
  }
}

export default user
